import { render } from "./TestShare.vue?vue&type=template&id=1ee91815&scoped=true"
import script from "./TestShare.vue?vue&type=script&lang=js"
export * from "./TestShare.vue?vue&type=script&lang=js"

import "./TestShare.vue?vue&type=style&index=0&id=1ee91815&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee91815"]])

export default __exports__